import {
  Container,
  Title,
  Text,
  List,
  ListItem,
  Space,
  Paper,
} from "@mantine/core";
import dayjs from "dayjs";
import { AppName, ContactInformation, LogoFull } from "../../Lib/Data";

import "./styles.scss";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  document.title = `Privacy Policy | ${AppName}`;

  return (
    <Container size="md" py="xl" className="privacy-policy-container">
      <div className="flex-row align-center justify-center width-100">
        <Link to="/">
          <img className="logo pointer" src={LogoFull} alt="" />
        </Link>
      </div>
      <Paper withBorder p={40} radius="lg" mt="xl" shadow="sm">
        <Title order={2} ta="center" mb="sm">
          Privacy Policy
        </Title>
        <Text size="sm" c="dimmed" ta="center" mb="xl">
          Effective Date: {dayjs().format("MMMM D, YYYY")}
        </Text>

        <Title order={3} mt="md">
          1. Information We Collect
        </Title>
        <List spacing="sm" size="sm" withPadding>
          <ListItem>
            <strong>Personal Information:</strong> Name, email, phone number,
            payment information.
          </ListItem>
          <ListItem>
            <strong>Account Information:</strong> Service-specific login details
            for shared subscriptions.
          </ListItem>
          <ListItem>
            <strong>Usage Data:</strong> How you interact with {AppName},
            anonymized.
          </ListItem>
          <ListItem>
            <strong>Cookies:</strong> Used for a better experience and
            analytics.
          </ListItem>
        </List>

        <Title order={3} mt="xl">
          2. How We Use Your Information
        </Title>
        <List spacing="sm" size="sm" withPadding>
          <ListItem>Create and manage your account.</ListItem>
          <ListItem>Process payments and manage subscriptions.</ListItem>
          <ListItem>Provide customer support.</ListItem>
          <ListItem>Send important updates and transaction emails.</ListItem>
          <ListItem>Improve and personalize {AppName} services.</ListItem>
        </List>

        <Title order={3} mt="xl">
          3. Sharing Your Information
        </Title>
        <Text size="sm" mb="sm">
          We do not sell your data. Information may be shared with:
        </Text>
        <List spacing="sm" size="sm" withPadding>
          <ListItem>Payment processors.</ListItem>
          <ListItem>Service providers helping our operations.</ListItem>
          <ListItem>Law enforcement if legally required.</ListItem>
          <ListItem>To protect rights and safety.</ListItem>
        </List>

        <Title order={3} mt="xl">
          4. Data Retention
        </Title>
        <Text size="sm">
          We retain your data while your account is active and afterward to meet
          legal requirements. You can request deletion anytime.
        </Text>

        <Title order={3} mt="xl">
          5. Your Rights
        </Title>
        <List spacing="sm" size="sm" withPadding>
          <ListItem>Access your data.</ListItem>
          <ListItem>Request correction or deletion.</ListItem>
          <ListItem>Object to or restrict data processing.</ListItem>
          <ListItem>Withdraw consent at any time.</ListItem>
        </List>

        <Title order={3} mt="xl">
          6. Data Security
        </Title>
        <Text size="sm">
          We use appropriate security measures to protect your information,
          though no method is 100% secure.
        </Text>

        <Title order={3} mt="xl">
          7. Third-Party Services
        </Title>
        <Text size="sm">
          We may link to external sites. We are not responsible for their
          privacy practices.
        </Text>

        <Title order={3} mt="xl">
          8. Changes to This Policy
        </Title>
        <Text size="sm">
          We may update this policy. We'll notify you by email or site notice
          before changes take effect.
        </Text>

        <Title order={3} mt="xl">
          9. Contact Us
        </Title>
        <Text size="sm">
          Questions? Email us at <strong>{ContactInformation.email}</strong>.
        </Text>
      </Paper>
      <Space h="xl" />
    </Container>
  );
}
